import { GeneralSettingsParams } from '../../../../../../../../stores/GeneralSettings/generalSettings.types';
import { Team } from '../../../../../../../context/ApplicationContext/applicationContext.types';
import { BrandGeneralSettingsQueryKeysAndFnGenerator } from './generators/brandGeneralSettingsQueryKeysAndFnGenerator';
import { CatalogsQueryKeysAndFnGenerator } from './generators/catalogsQueryKeysAndFnGenerator';
import { CategoriesQueryKeysAndFnGenerator } from './generators/categoriesQueryKeysAndFnGenerator';
import { ClassificationTypesQueryKeysAndFnGenerator } from './generators/classificationTypesQueryKeysAndFnGenerator';
import { ClassificationsQueryKeysAndFnGenerator } from './generators/classificationsQueryKeysAndFnGenerator';
import { CollectionsQueryKeysAndFnGenerator } from './generators/collectionsQueryKeysAndFnGenerator';
import { ColorsQueryKeysAndFnGenerator } from './generators/colorsQueryKeysAndFnGenerator';
import { CustomerQueryKeysAndFnGenerator } from './generators/customersQueryKeysAndFnGenerator';
import { ImagesQueryKeysAndFnGenerator } from './generators/imagesQueryKeysAndFnGenerator';
import { KitsQueryKeysAndFnGenerator } from './generators/kitsQueryKeysAndFnGenerator';
import { PriceTablesQueryKeysAndFnGenerator } from './generators/priceTablesQueryKeysAndFnGenerator';
import { ProductsQueryKeysAndFnGenerator } from './generators/productsQueryKeysAndFnGenerator';
import { ReferenceColorsQueryKeysAndFnGenerator } from './generators/referenceColorsQueryKeysAndFnGenerator';
import { SalesRepresentativesQueryKeysAndFnGenerator } from './generators/salesRepresentativesQueryKeysAndFnGenerator';
import { SellersQueryKeysAndFnGenerator } from './generators/sellersQueryKeysAndFnGenerator';
import { QueryKeysAndFnGenerator, QueryKeysAndFnGeneratorParams } from './generators/types';

export class DynamicQueryKeysAndFnFactory {
  private generators: QueryKeysAndFnGenerator[] = [];
  private readonly DEFAULT_PRIORITY = 1;

  constructor({ isSeller, webpEnabled, userTeam, generalSettings }: ConstructorParams) {
    const params: QueryKeysAndFnGeneratorParams = {
      isSeller,
      userTeam,
      webpEnabled,
      generalSettings,
      priority: this.DEFAULT_PRIORITY,
    };

    this.generators.push(
      new KitsQueryKeysAndFnGenerator(params),
      new ImagesQueryKeysAndFnGenerator(params),
      new ColorsQueryKeysAndFnGenerator(params),
      new SellersQueryKeysAndFnGenerator(params),
      new ProductsQueryKeysAndFnGenerator(params),
      new CustomerQueryKeysAndFnGenerator(params),
      new CategoriesQueryKeysAndFnGenerator(params),
      new PriceTablesQueryKeysAndFnGenerator(params),
      new CollectionsQueryKeysAndFnGenerator(params),
      new ReferenceColorsQueryKeysAndFnGenerator(params),
      new ClassificationsQueryKeysAndFnGenerator(params),
      new ClassificationTypesQueryKeysAndFnGenerator(params),
      new SalesRepresentativesQueryKeysAndFnGenerator(params),
      new BrandGeneralSettingsQueryKeysAndFnGenerator(params),
      new CatalogsQueryKeysAndFnGenerator({ ...params, priority: 2 }),
    );
  }

  async create() {
    const generatorsOutputs = await Promise.all(
      this.generators.map((generator) => generator.generateQueryKeysAndFn()),
    );

    return generatorsOutputs.flat();
  }
}

interface ConstructorParams {
  userTeam: Team;
  isSeller: boolean;
  webpEnabled: boolean;
  generalSettings: GeneralSettingsParams;
}
